import axios from 'axios'

export default {
  namespaced: true,

  actions: {
    deleteWorkshop(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/delete",
          data: obj,
          method: "DELETE"
        }).then(response => {
          if (response.data.code === 201) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    enrolledStudent({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/enroll/bybranch?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 201) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    disenrollStudent({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/disenroll/bybranch?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 201) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getStudentsFromWorkShop({
      rootGetters
    }, obj) {
        return new Promise((resolve, reject) => {
          axios({
            url: process.env.VUE_APP_URL + "/student/web/toenrolled/bybranch?id=" + rootGetters.getBranch.id,
            data: obj,
            method: "PUT"
          }).then(response => {
            if (response.data.status) {
              resolve(response);
            } else {
              reject(response)
            }
          }).catch(error => {
            reject(error)
          })
        })
    },
    getStudentsToEnrolled({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/enrolled/bybranch?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getWorkshops({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/getbybranch?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createWorkshop(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/create",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.code === 201) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateWorkshop(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/course/web/update",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 200) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createStudent(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/student/web/create",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateStudent(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/student/web/update",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteStudents(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/student/web/deleteV2",
          data: obj,
          method: "DELETE"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAttendancesStudents(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/entries/report/CourseAttendance/all",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 200) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}